module.exports = __webpack_public_path__ + "static/media/halo-massage-mobile.31a410bd.svg";